import FullfillRef from "./fullfill_refspm";
var fullfill = function fullfill(tracert, cb) {
  var Tracert = tracert;
  var fullfillRef = new FullfillRef(Tracert);
  Tracert.set({
    fullfillRef: fullfillRef
  });
  cb();
  return Tracert;
};
export default fullfill;